import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { PartyService, ExcelService } from "../../../services/index";
import * as commonActions from "../../../store/actions/common.actions";
import { AddEditParty } from "./addEditParty";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./party.html",
})
export class PartyComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  purchase_type: boolean = false;
  exceldata: any;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter: any = {
    name: "",
    agent_id: "",
    status: "",
    purchase_name: "",
    party_type: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "name",
    orderDir: "asc",
  };
  statusList = [{ name: "ACTIVE" }, { name: "INACTIVE" }];
  finyearList = [];
  agentList = [];
  typeList = ["SALES PARTY", "PURCHASE PARTY"];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("transportTemplate") transportTemplate;

  finyearCtrl: FormControl = new FormControl();
  statusControl: FormControl = new FormControl();
  agentControl: FormControl = new FormControl();
  partyControl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  pname: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private partyService: PartyService,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private excelService: ExcelService
  ) {}

  ngOnInit(): void {
    if(this.menu.param == 'SALES PARTY'){
      this.filter.party_type = 'SALES PARTY';
      this.getAgentList();
    }else{
      this.filter.party_type = 'PURCHASE PARTY';
      this.purchase_type = true;
      this.getPurchaseAgentList();
    }
    this.getColumns();

    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    if(this.menu.param == 'SALES PARTY'){
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
        {
        name: "PartyID",
        prop: "genLedid",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Code",
        prop: "party_code",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Name",
        prop: "name",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Address",
        prop: "address",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "City",
        prop: "city",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Pincode",
        prop: "pin",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Agent",
        prop: "agent_name",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Type",
        prop: "type",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Gst no",
        prop: "gst_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Transport",
        prop: "designation",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        sortable: false,
      },
      {
        name: "BoxLess",
        prop: "boxless",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        sortable: false,
      },
      {
        name: "Line",
        prop: "line",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        sortable: false,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },

    ];
  }
  else{
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Code",
        prop: "code",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Name",
        prop: "party_name",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Address",
        prop: "address1",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "City",
        prop: "city",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Pincode",
        prop: "pincode",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Agent",
        prop: "agent_name",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Type",
        prop: "type",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Gst no",
        prop: "gst_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      
      {
        name: "Action",
        prop: "sno",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },

    ];
  }
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "apply") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      this.applyFilter();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getParty();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.name = "";
    this.filter.agent_id = "";
    this.filter.genLedid = "";
    this.filter.agent_name = "";
    this.filter.purchase_name = "";
    this.filter.status = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    // this.filter.name=='';
    // this.filter.agent_id='';
    // this.filter.status='';
    this.getParty();
  }

  bsModalRef: BsModalRef;
  addEditParty(mode: string, row: any): void {
    let that = this;
    setTimeout(function () {
      that.filterPanel.close();
    }, 10);

    if (mode == "Add") {
      row = {
        userid: "",
        username: "",
        password: "",
        fullname: "",
        address: "",
        phone: "",
        email: "",
        usertype: "",
        doj: "",
        status: "",
        designation: "",
      };
    }
    // if (mode == "View") {
    // that.bsModalRef = that.modalService.show(AddEditParty, {
    //     keyboard: false,
    //     ignoreBackdropClick: true,
    //     class: 'modal-lg'
    // });
    // that.bsModalRef.content.title = mode + this.title;
    // that.bsModalRef.content.mode = mode;
    // row.mode = mode;
    //  this.bsModalRef.content.partydata = Object.assign({}, row);
    // }
    if (row.type == "SALES") {
      let params = {
        genLedid: row.genLedid,
      };
      that.partyService.editSalesParty(params).then(function (res: any) {
        // that.loadingIndicator = false;
        let data: any = res.data[0];
        that.bsModalRef = that.modalService.show(AddEditParty, {
          keyboard: false,
          ignoreBackdropClick: true,
          class: "sales_model",
        });
        that.bsModalRef.content.title = mode + that.title;
        that.bsModalRef.content.mode = mode;
        data.mode = mode;

        that.bsModalRef.content.partydata = Object.assign({}, data);
        (that.bsModalRef.content.tabID = that.tabID),
          (that.bsModalRef.content.tabTitle = that.title),
          that.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
            that.getParty();
            if (that.title == "Party")
              that.store.dispatch(new commonActions.LoadAllParty());
            else that.store.dispatch(new commonActions.LoadAllCompany());
          });
      });
    }
    if (row.type == "PURCHASE") {
      let params = {
        party_id: row.party_id,
      };
      that.partyService.editPurchaseParty(params).then(function (res: any) {
        // that.loadingIndicator = false;
        let data: any = res.data[0];
        that.bsModalRef = that.modalService.show(AddEditParty, {
          keyboard: false,
          ignoreBackdropClick: true,
          class: "sales_model",
        });
        that.bsModalRef.content.title = mode + that.title;
        that.bsModalRef.content.mode = mode;
        data.mode = mode;

        that.bsModalRef.content.partydata = Object.assign({}, data);
        (that.bsModalRef.content.tabID = that.tabID),
          (that.bsModalRef.content.tabTitle = that.title),
          that.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
            that.getParty();
            if (that.title == "Party")
              that.store.dispatch(new commonActions.LoadAllParty());
            else that.store.dispatch(new commonActions.LoadAllCompany());
          });
      });
    }

    // that.isLoadMask = that.partyService
    //     .editSalesParty(params)
    //     .then(function (res: any) {
    //         that.loadingIndicator = false;
    //         let data  = res.data[0];
    //         that.bsModalRef = that.modalService.show(AddEditParty, {
    //             keyboard: false,
    //             ignoreBackdropClick: true,
    //             class: 'modal-lg'
    //         });
    //         that.bsModalRef.content.title = mode + this.title;
    //         that.bsModalRef.content.mode = mode;
    //         that.bsModalRef.content.partydata = Object.assign({}, data);
    //     });

    // this.bsModalRef.content.tabID = this.tabID,
    //     this.bsModalRef.content.tabTitle = this.title,
    //     this.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
    //         that.getParty();
    //         if (this.title == "Party")
    //             this.store.dispatch(new commonActions.LoadAllParty());
    //         else
    //             this.store.dispatch(new commonActions.LoadAllCompany());
    //     });
    if (row["type"] == undefined) {
      that.bsModalRef = that.modalService.show(AddEditParty, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "sales_model",
      });
      that.bsModalRef.content.title = mode + this.title;
      that.bsModalRef.content.mode = mode;
      row.mode = mode;
      this.bsModalRef.content.partydata = Object.assign({}, row);
      (that.bsModalRef.content.tabID = that.tabID),
        (that.bsModalRef.content.tabTitle = that.title),
        that.bsModalRef.content.partyUpdateEvent.subscribe(($e) => {
          that.getParty();
          if (that.title == "Party")
            that.store.dispatch(new commonActions.LoadAllParty());
          else that.store.dispatch(new commonActions.LoadAllCompany());
        });
    }
  }
  getParty(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      agent_id: this.filter.agent_id,
      name: this.filter.name,
      status: this.filter.status,
      purchase_name: this.filter.purchase_name,
      party_type: this.filter.party_type,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.partyService
      .getPartyList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.partyList = res.data;
      });
  }

  exportToExcel($event) {
    let params = {
      party_type: this.filter.party_type,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    that.isLoadMask = that.partyService
      .getExcelPartyList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;

        that.exceldata = that.getData(res.columns, res.data);
        that.excelService.exportAsExcelFile(that.exceldata, that.title);
      });
    
  }

  getData(columns, data) {
    let cols = columns;
    let rows = [],
      row,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  deleteParty(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Party Details?",
      text: "You will not be able to recover this party",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        if (row.type == "SALES") {
          that.isLoadMask = that.partyService
            .delete(row)
            .then(function (res: any) {
              that.loadingIndicator = false;
              that.getParty();
              let errtype = "warn",
                errmsg = res.message;
              if (!res.success) {
                errtype = "error";
              }

              that.toasterService.pop({
                bodyOutputType: 1,
                type: errtype,
                title: errtype.toUpperCase(),
                body: errmsg,
              });
            });
        }

        if (row.type == "PURCHASE") {
          that.isLoadMask = that.partyService
            .deletePurchaseParty(row)
            .then(function (res: any) {
              that.loadingIndicator = false;
              that.getParty();
              let errtype = "warn",
                errmsg = res.message;
              if (!res.success) {
                errtype = "error";
              }

              that.toasterService.pop({
                bodyOutputType: 1,
                type: errtype,
                title: errtype.toUpperCase(),
                body: errmsg,
              });
            });
        }
      },
      function (dismiss) {}
    );
  }
  
  getAgentList() {
    let that = this;
    that.partyService.getAgentList({}).then((res: any) => {
      this.agentList = res;
   
    });
   
  }
  
  getPurchaseAgentList() {
   
    let that = this;
    that.partyService.getPurchaseAgentList({}).then((res: any) => {
      this.agentList = res;
   
    });
 
  }

  onSelectsalesagent(type){
    let data = this.agentList;
    let obj = data.find(o => o.name === type);
     
       this.filter.agent_id = obj.genLedid;
           
  }
  onSelectpurchaseagent(type){
    let data = this.agentList;
    let obj = data.find(o => o.agent_name === type);
     
       this.filter.agent_id = obj.agent_id;
           
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/party/party.ts